import { getAmplitudeInstance } from '../amplitudeHelpers';
import PaymentMethod from '../enums/PaymentMethod';
import PurchaseScreenTypePlan from '../enums/PurchaseScreenTypePlan';
import UpsellTrigger from '../enums/UpsellTrigger';

type logPurchaseFailedParams = {
  campaign_id?: string;
  error_code?: string;
  failure_type?: string;
  payment_method?: PaymentMethod;
  phase?: string;
  product_id?: string;
  purchase_screen_type_plan?: PurchaseScreenTypePlan;
  transaction_date?: string;
  transaction_id?: string;
  upsell_trigger?: UpsellTrigger;
  user_id?: string;
};

/**
 * The pro purchase flow failed for a user.  This can include failure during charging or errors upgrading the user's account to pro.
 * @param params - Attributes to log with the amplitude event
 * @param params.campaign_id - Imported from a Firebase call
 * @param params.error_code - Imported from a Firebase call
 * @param params.failure_type - Imported from a Firebase call
 * @param params.payment_method - The method of payment used for the purchase.
 * @param params.phase - Imported from a Firebase call
 * @param params.product_id - Imported from a Firebase call
 * @param params.purchase_screen_type_plan - The plan shown on the pro purchasing event occurs on (e.g. trial, non-trial, promo, etc.)
 * @param params.transaction_date - Imported from a Firebase call
 * @param params.transaction_id - Imported from a Firebase call
 * @param params.upsell_trigger - Action that triggered the upsell to display
 * @param params.user_id - Imported from a Firebase call
 */
const logPurchaseFailed = (
  {
    campaign_id,
    error_code,
    failure_type,
    payment_method,
    phase,
    product_id,
    purchase_screen_type_plan,
    transaction_date,
    transaction_id,
    upsell_trigger,
    user_id
  }: logPurchaseFailedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'purchase failed',
    {
      'campaign id': campaign_id,
      'error code': error_code,
      'failure type': failure_type,
      'payment method': payment_method,
      phase,
      'product id': product_id,
      'purchase screen type plan': purchase_screen_type_plan,
      'transaction date': transaction_date,
      'transaction id': transaction_id,
      'upsell trigger': upsell_trigger,
      'user id': user_id
    },
    callback
  );
};

export default logPurchaseFailed;
